<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>inventory_2</mat-icon></div>
          <mat-card-title>
            Comodato
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <form *ngIf="formulario && !carregando" [formGroup]="formulario" (ngSubmit)="submit()">
          <app-comodato-cadastro
            [formulario]="formulario"
            (buscarCliente)="buscarClient()"
            (buscarProduto)="buscarProduto()">
          </app-comodato-cadastro>

          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()">
              <mat-icon>arrow_back</mat-icon> Voltar
            </button>
            <button type="button" mat-stroked-button (click)="limpar()">
              <mat-icon>clear</mat-icon> Limpar
            </button>
            <button type="submit" mat-raised-button color="primary" [disabled]="!formulario.valid">
              <mat-icon>save</mat-icon> Salvar
            </button>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
</main>
